//region :: Imports ::
import MComponent from '../../Component';
import {IMsalContext} from '@azure/msal-react';
import {createRef, ReactElement, RefObject, Fragment} from 'react';
import MTextBox, {MInputValueType} from '../TextBox';
import {MBoolean} from '../Control';
import MDynEntityLookupDialog from './DynEntityLookupDialog';
import MButton from '../Button';
import {SearchIconName} from '../../../Icons';
import {FieldProps} from 'formik';

//endregion

/** */
type Props = {
    id: string;
    initialValue?: MInputValueType;
    environmentUrl: string;
    entityLogicalName: string;
    searchFieldName: string;
    searchFilter?: string;
    authContext: IMsalContext;
    fieldProps?: FieldProps;
    disabled: MBoolean;
    className?: string;
    onChange?: (id: string, name: string, entity: any) => void;
}

/** */
class MDynEntityLookup extends MComponent<Props> {

    private readonly m_lookupDialogRef: RefObject<MDynEntityLookupDialog>;
    private readonly m_textBoxRef: RefObject<MTextBox>;

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.m_lookupDialogRef = createRef<MDynEntityLookupDialog>();
        this.m_textBoxRef = createRef<MTextBox>();

    }

    /** */
    private bindMethods(): void {

        this.searchButton_onClick = this.searchButton_onClick.bind(this);
        this.searchDialog_onClose = this.searchDialog_onClose.bind(this);

    }

    /** */
    private async searchButton_onClick(): Promise<void> {
        await this.m_lookupDialogRef.current!.show();
    }

    /** */
    private searchDialog_onClose(id: string, name: string, entity: any): void {

        this.m_textBoxRef.current!.setValue(name);
        this.props.onChange?.(id, name, entity);

    }

    /** */
    public render(): ReactElement {

        return (

            <Fragment>

                <div className="p-inputgroup">

                    <MTextBox id={this.props.id}
                              maxLength={1000}
                              readonly={true}
                              fieldProps={this.props.fieldProps}
                              disabled={this.props.disabled}
                              className={this.props.className}
                              ref={this.m_textBoxRef}/>

                    <MButton icon={SearchIconName}
                             iconOnly={true}
                             onClick={this.searchButton_onClick}
                             disabled={this.props.disabled}/>

                </div>

                <MDynEntityLookupDialog environmentUrl={this.props.environmentUrl}
                                        entityLogicalName={this.props.entityLogicalName}
                                        searchFieldName={this.props.searchFieldName}
                                        searchFilter={this.props.searchFilter}
                                        tableFieldNames={[this.props.searchFieldName]}
                                        columnWidth={100}
                                        authContext={this.props.authContext}
                                        onClose={this.searchDialog_onClose}
                                        ref={this.m_lookupDialogRef}/>

            </Fragment>

        );

    }

}

export default MDynEntityLookup;
